jQuery(function ($) {
	var $form = $('form.variations_form');

	if (!$form.length) {
		return;
	}

	function syncRadiosFromSelect($fieldset) {
		var $select = $fieldset.find('.card-variation-radios__select');
		var value = $select.val();
		var $radios = $fieldset.find('.card-variation-radios__input');

		$radios.prop('checked', false);
		$radios.filter('[value="' + value + '"]').prop('checked', true);
	}

	function syncSelectFromRadio($radio) {
		var $fieldset = $radio.closest('.card-variation-radios');
		var $select = $fieldset.find('.card-variation-radios__select');

		$select.val($radio.val()).trigger('change');
		$form.trigger('check_variations');
	}

	$form.find('.card-variation-radios').each(function () {
		syncRadiosFromSelect($(this));
	});

	$form.on('change', '.card-variation-radios__input', function () {
		syncSelectFromRadio($(this));
	});

	$form.on('click', '.card-variation-radios__item--disabled .card-variation-radios__label', function (event) {
		event.preventDefault();
	});

	$form.on('reset_data', function () {
		$form.find('.card-variation-radios__input').prop('checked', false);
		$form.find('.card-variation-radios__select').each(function () {
			syncRadiosFromSelect($(this).closest('.card-variation-radios'));
		});
	});

	$form.on('woocommerce_update_variation_values', function () {
		$form.find('.card-variation-radios').each(function () {
			syncRadiosFromSelect($(this));
		});
	});
});
